import { CallContent } from "../../../Components/CallApp/CallApp";

export const WhiteHouseCallContent: CallContent[] = [
  {
    Contact: "John Kewel",
    date: "7 Dec 2022",
    time: "4:46 PM",
    type: "outgoing",
  },
  {
    Contact: "Angie Poulter",
    date: "6 Dec 2022",
    time: "8:43 PM",
    type: "outgoing",
  },
  {
    Contact: "Angie Poulter",
    date: "6 Dec 2022",
    time: "7:11 PM",
    type: "missed",
  },
  {
    Contact: "Patrick Spiro",
    date: "6 Dec 2022",
    time: "4:01 PM",
    type: "incoming",
  },
  {
    Contact: "Patrick Spiro",
    date: "6 Dec 2022",
    time: "3:15 PM",
    type: "outgoing",
  },
  {
    Contact: "Bill Kowalski",
    date: "6 Dec 2022",
    time: "1:57 PM",
    type: "outgoing",
  },
  {
    Contact: "Gina Harman",
    date: "6 Dec 2022",
    time: "12:15 PM",
    type: "incoming",
  },
  {
    Contact: "Carmen Di Motta",
    date: "6 Dec 2022",
    time: "9:54 PM",
    type: "outgoing",
  },
];
